/**
 * Случайный идентификатор.
 *
 * `crypto.randomUUID` есть только в защищённом контексте: по HTTPS и на
 * localhost. Система ставится в закрытый контур, где сертификата может
 * не быть вовсе, — и там этой функции просто нет. Без запасного пути первая же
 * попытка что-нибудь изменить обрывается ошибкой, а экран становится белым:
 * ключ идемпотентности вычисляется раньше самого запроса.
 *
 * Запасной путь — та же случайность из `getRandomValues`, которая доступна
 * всегда, разложенная по формату UUID версии 4.
 */

export function randomId(): string {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Версия и вариант — по RFC 4122: без них это просто шестнадцать случайных
  // байтов, а принимающая сторона вправе ждать именно UUID
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;

  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
